import { Table } from 'antd';
import { useState } from 'react';
import { loadingIndicator } from '../../../../../components/common/spinner/LoadingIndicator';
import { useGetAllInvoiceClientQuery } from '../../../Client/api/endpoints/clientEndpoints';
import { clientInvoiceUtil } from '../../../Client/utils/utils_tsx/clientInvoiceUtil';

type Props = { id: string };

const CombineClientDetailInvoice = ({ id }: Props) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const { data, isLoading } = useGetAllInvoiceClientQuery({
    ...pagination,
    id: `combined-${id}`,
  });

  return (
    <div>
      <Table
        size='small'
        columns={clientInvoiceUtil()}
        dataSource={data?.data}
        pagination={
          data?.count !== undefined && data?.count < 20
            ? false
            : {
              ...pagination,
              total: data?.count,
              showSizeChanger: true,
              pageSizeOptions: ['50', '100', '200', '500'],
              onChange: handlePaginationChange,
            }
        }
        scroll={{ x: true }}
        loading={{
          spinning: isLoading,
          indicator: loadingIndicator,
        }}
      />
    </div>
  );
};

export default CombineClientDetailInvoice;
